<template>
	<div
		class="cnt-cropper"
		ref="cnt"
		:style="{ width: container[0] + 'px', height: container[1] + 'px' }"
	>
		<label v-show="imgPreCrop == '' && value == ''" class="load-image">
			Carregar Imagem
			<small v-if="crop !== false">{{ crop[0] }} X {{ crop[1] }}</small>
			<input
				type="file"
				ref="inputLoadImage"
				@change="loadImage($event.target.files)"
				class="hide"
				:accept="accept.join(',')"
			/>
		</label>
		<div v-if="imgPreCrop != ''" class="pre-crop">
			<button
				@click="reLoadImage"
				title="Recarregar Imagem"
				class="btn-reupload btn-warning"
			>
				<i class="fa fa-upload"></i>
			</button>
			<img :src="imgPreCrop" ref="image" class="hide" />
			<button
				@click="croper"
				title="Cortar Imagem"
				class="btn-crop btn-info"
			>
				<i class="fa fa-crop"></i>
			</button>
		</div>
		<div v-if="imgPreCrop == '' && value != ''" class="view">
			<button
				@click="reLoadImage"
				title="Recarregar Imagem"
				class="btn-reupload btn-warning"
			>
				<i class="fa fa-upload"></i>
			</button>
			<img :src="preview" class="thumbnail no-padding" />
		</div>
	</div>
</template>
<script>
	import toastr from 'toastr';
	import Cropper from 'cropperjs';
	import 'cropperjs/dist/cropper.css';
	import WBS from 'js/http';
	import clone from 'js/clone';

	export default {
		name: 'AppCropImage',
		data() {
			return {
				imgPreCrop: '',
				cropperInstance: null,
				type: 'image/jpeg',
				dataFile: null,
			};
		},
		props: {
			crop: {
				default: false,
			},
			path: {
				default: 'croped-files',
				required: true,
			},
			maxSize: {
				default: -1,
				type: Number,
			},
			value: {
				default: '',
			},
			accept: {
				default: (e) => ['image/jpeg', 'image/png'],
				type: Array,
			},
			container: {
				default: false,
			},
		},
		computed: {
			preview() {
				if (typeof this.value == 'object')
					return `${WBS.url_base}/uploaded_files/${this.path}/${this.value.file}`;
				else return this.value;
			},
		},
		methods: {
			saveFile(file) {
				let SendData = {
					path: this.path,
					file: {
						name: this.dataFile.name,
						size: this.dataFile.size,
						type: this.dataFile.type,
						date: this.dataFile.lastModified,
					},
					baseCroped: file,
				};
				WBS.send('protected-save-croppedFile', SendData, (resp) => {
					if (resp.status == 'success') {
						this.$emit('input', resp.data);
						setTimeout((e) => {
							this.imgPreCrop = '';
							this.cropperInstance.destroy();
							this.cropperInstance = null;
						}, 100);
					} else {
						console.log(resp);
					}
				});
			},
			removeOld() {
				return new Promise((resolve, reject) => {
					if (this.value == '' || typeof this.value == 'string')
						resolve(false);
					let sData = clone(this.value);
					sData.path = this.path;
					WBS.send('protected-delete-croppedImage', sData, (resp) => {
						resolve(false);
					});
				});
			},
			croper() {
				let imgCroped = null;
				if (this.crop != false) {
					imgCroped = this.cropperInstance
						.getCroppedCanvas({
							width: this.crop[0],
							height: this.crop[1],
						})
						.toDataURL(this.type);
				} else {
					imgCroped = this.cropperInstance.toDataURL(this.type);
				}

				if (imgCroped != '') {
					this.saveFile(imgCroped);
				}
			},
			reLoadImage() {
				$(this.$refs.inputLoadImage).click();
			},
			vMaxSize(file) {
				if (this.maxSize == -1) return false;
				else if (file.size < this.maxSize) return false;
				else {
					toastr.warning(
						'O arquivo selecionado é maior que o permitido!'
					);
					return true;
				}
			},
			vAccepts(type) {
				if (this.accept.indexOf(type) != -1) return false;
				else {
					toastr.warning('Este tipo de arquivo não é permitido!');
					return true;
				}
			},
			loadCropper() {
				setTimeout((e) => {
					let opts = {
						responsive: true,
						cropBoxResizable: true,
						viewMode: 2,
						minContainerWidth: 50,
						minContainerHeight: 50,
					};

					if (this.container != false) {
						opts.minContainerWidth = this.container[0];
						opts.minContainerHeight = this.container[1];
					} else {
						opts.minContainerWidth = $(this.$refs.cnt).width();
						opts.minContainerHeight =
							this.crop[1] || $(this.$refs.cnt).width() / 2;
					}

					if (this.crop != false)
						opts.aspectRatio = this.crop[1] / this.crop[1];
					this.cropperInstance = new Cropper(this.$refs.image, opts);
				}, 100);
			},
			async loadImage(files) {
				// Bloqueio de errors
				if (files.length == 0) return;
				this.dataFile = files[0];

				if (this.vMaxSize(this.dataFile)) return;
				if (this.vAccepts(this.dataFile.type)) return;
				if (await this.removeOld()) return;

				if (this.cropperInstance != null)
					this.cropperInstance.destroy();
				let reader = new FileReader();
				reader.onload = (e) => {
					this.imgPreCrop = e.target.result;
					this.type = this.dataFile.type;
					this.loadCropper();
				};
				reader.readAsDataURL(this.dataFile);
			},
		},
	};
</script>
<style scoped>
	.cnt-cropper {
		display: inline-block;
		position: relative;
		height: max-content;
		/*width: 100%;*/
	}
	.thumbnail {
		margin-bottom: 0px;
	}
	.pre-crop,
	.view {
		display: block;
		width: max-content;
		height: max-content;
		position: relative;
	}
	.load-image {
		text-align: center;
		display: block;
		width: 100%;
		border: 1px solid #d2d6de;
		height: max-content;
		color: #87888c;
		font-size: 20px;
		padding: 28px 0px;
		background: #fbfbfb;
		cursor: pointer;
		font-weight: 100;
	}
	.load-image small {
		display: block;
		font-size: 15px;
		color: #d2d6de;
	}
	.btn-crop:focus,
	.btn-reupload:focus {
		outline: none;
	}

	.btn-reupload,
	.btn-crop {
		position: absolute;
		top: 50%;
		z-index: 10;
		margin-top: -15px;
		border-radius: 100px;
		border: none;
		color: #fff;
		width: 30px;
		height: 30px;
	}
	.btn-reupload {
		left: -15px;
		/*background-color: #00a65a;*/
	}
	.btn-crop {
		right: -15px;
		/*background-color: #00a65a;*/
	}
</style>



// WEBPACK FOOTER //
// src/app-components/cropImage/index.vue